// Design tokens — all values resolve to CSS variables defined in index.css.
// Switching themes is a single attribute change on <html>.
// Token names are kept stable so existing component code keeps working.
export const C = {
  bg:           'var(--bg)',
  surface:      'var(--surface)',
  surface2:     'var(--surface-2)',
  card:         'var(--card)',
  sidebar:      'var(--sidebar)',
  border:       'var(--border)',
  border2:      'var(--border-2)',
  borderSubtle: 'var(--border-subtle)',
  primary:      'var(--primary)',
  primaryHover: 'var(--primary-hover)',
  primarySoft:  'var(--primary-soft)',
  primaryGlow:  'var(--primary-glow)',
  violet:       'var(--violet)',
  text1:        'var(--text-1)',
  text2:        'var(--text-2)',
  text3:        'var(--text-3)',
  blue:         'var(--blue)',
  success:      'var(--success)',
  warning:      'var(--warning)',
  danger:       'var(--danger)',
};

// Status badge styles
export const statusBadge = (s) => {
  const map = {
    'Waiting for QA':    { color: 'var(--warning)', bg: 'rgba(245,158,11,0.10)',  border: 'rgba(245,158,11,0.22)'  },
    'In Progress':       { color: '#22d3ee',        bg: 'rgba(34,211,238,0.10)',  border: 'rgba(34,211,238,0.22)'  },
    'Approved':          { color: 'var(--success)', bg: 'rgba(16,185,129,0.10)',  border: 'rgba(16,185,129,0.22)'  },
    'Ready for Payment': { color: 'var(--blue)',    bg: 'rgba(96,165,250,0.10)',  border: 'rgba(96,165,250,0.22)'  },
    'Paid':              { color: '#a78bfa',        bg: 'rgba(167,139,250,0.10)', border: 'rgba(167,139,250,0.22)' },
    'Rejected':          { color: 'var(--danger)',  bg: 'rgba(248,113,113,0.10)', border: 'rgba(248,113,113,0.22)' },
  };
  const t = map[s] || { color: 'var(--text-2)', bg: 'rgba(128,128,140,0.08)', border: 'rgba(128,128,140,0.20)' };
  return {
    display: 'inline-block',
    padding: '4px 10px',
    borderRadius: '6px',
    fontSize: '12px',
    fontWeight: '600',
    letterSpacing: '0.04em',
    textTransform: 'uppercase',
    color: t.color,
    background: t.bg,
    border: `1px solid ${t.border}`,
  };
};

// Shared card style
export const card = {
  background: 'var(--card)',
  border: '1px solid var(--border)',
  borderRadius: '14px',
};
